"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFilterStateUrl = exports.parseUrlOnReportTabOpen = void 0;
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var parseUrlOnReportTabOpen = function (setListEntryType, pushUrl) {
    var urlParams = new URLSearchParams(window.location.search);
    var filterState = urlParams.get('reportListFilter');
    filterState === SokReducerTypes.TEMPLATE
        ? setListEntryType(filterState)
        : (0, exports.updateFilterStateUrl)(SokReducerTypes.REPORT, pushUrl);
};
exports.parseUrlOnReportTabOpen = parseUrlOnReportTabOpen;
var updateFilterStateUrl = function (filterState, pushUrl) {
    var urlParams = new URLSearchParams(window.location.search);
    var filterStateFromUrl = urlParams.get('reportListFilter') ||
        null;
    !filterStateFromUrl
        ? urlParams.append('reportListFilter', filterState)
        : urlParams.set('reportListFilter', filterState);
    pushUrl("".concat(window.location.pathname, "?").concat(urlParams.toString()));
};
exports.updateFilterStateUrl = updateFilterStateUrl;
